import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

const InfiniteLooper = ({ speed = 10, direction = 'left', children }) => {
  const [looperInstances, setLooperInstances] = useState(1);
  const outerRef = useRef(null);
  const innerRef = useRef(null);
  const orientation = direction === 'up' || direction === 'down' ? 'vertical' : 'horizontal';

  function resetAnimation() {
    if (innerRef?.current) {
      innerRef.current.setAttribute('data-animate', 'false');

      setTimeout(() => {
        if (innerRef?.current) {
          innerRef.current.setAttribute('data-animate', 'true');
        }
      }, 10);
    }
  }

  const setupInstances = useCallback(() => {
    if (!innerRef?.current || !outerRef?.current) return;

    const { width, height } = innerRef.current.getBoundingClientRect();

    const { width: parentWidth, height: parentHeight } = outerRef.current.getBoundingClientRect();

    if (orientation === 'vertical') {
      const heightDeficit = parentHeight - height;

      const childrenLength = innerRef.current.children.length;
      if (!childrenLength) return;

      const instanceHeight = height / childrenLength;

      if (heightDeficit) {
        setLooperInstances(looperInstances + Math.ceil(heightDeficit / instanceHeight) + 1);
      }
    } else {
      const widthDeficit = parentWidth - width;

      const childrenLength = innerRef.current.children.length;
      if (!childrenLength) return;

      const instanceWidth = width / childrenLength;
      if (widthDeficit) {
        setLooperInstances(looperInstances + Math.ceil(widthDeficit / instanceWidth) + 1);
      }
    }

    resetAnimation();
  }, [looperInstances, orientation]);

  /*
        6 instances, 200 each = 1200
        parent = 1700
    */

  useEffect(() => setupInstances(), [setupInstances]);

  useEffect(() => {
    window.addEventListener('resize', setupInstances);

    return () => {
      window.removeEventListener('resize', setupInstances);
    };
  }, [looperInstances, setupInstances]);

  return (
    <div className={styles.looper} ref={outerRef} orientation={orientation}>
      <div
        className={styles.looper__innerList}
        ref={innerRef}
        data-animate="true"
        orientation={orientation}
      >
        {[...Array(looperInstances)].map((_, ind) => (
          <div
            key={ind}
            className={styles.looper__listInstance}
            style={{
              animationDuration: `${speed}s`,
              animationDirection:
                direction === 'right' || direction === 'down' ? 'reverse' : 'normal',
            }}
          >
            {children}
          </div>
        ))}
      </div>
    </div>
  );
};

InfiniteLooper.propTypes = {
  speed: PropTypes.number,
  direction: PropTypes.oneOf(['left', 'right', 'up', 'down']),
  children: PropTypes.node,
};

export default InfiniteLooper;
